import React, { createContext, useContext, useState } from "react";
import {
  Dialog,
  DialogType,
  DialogFooter,
} from "@fluentui/react/lib/Dialog";
import { Button, DatePicker, notification, Progress, Radio, Space } from "antd";

import MonthlyPerformanceStore from "./store/monthlyperformancestore";
import { observer } from "mobx-react-lite";
import Form from "antd/lib/form/Form";
import FormItem from "antd/lib/form/FormItem";
import moment from "moment";
import { ProgressIndicator } from "@fluentui/react";
import { getPickerDate } from "../../Utility/modules/datePicker";
const { RangePicker } = DatePicker;
const modalPropsStyles = { main: { maxWidth: 600 } };
const _ = require("underscore");

const dialogContentProps = {
  type: DialogType.normal,
  title: "Production Date Query",
  subText:
    "View NAOC monthly  string production data for specific production month or month ranges",
};
const MonthlyPerformanceStoreCtx = createContext(MonthlyPerformanceStore);
export const SQuery = observer(() => {
  const [queryType, setQueryType] = useState("specific");
  const [queryDate, setQueryDate] = useState({ startDate: "", endDate: "" });
  const [loading, setLoading] = useState(false);
  const monthlyPerformanceStore = useContext(MonthlyPerformanceStoreCtx);

  return (
    <Dialog
      hidden={!monthlyPerformanceStore.showSQeryDialog}
      onDismiss={() => {
        monthlyPerformanceStore.showSQeryDialog = false;
      }}
      dialogContentProps={dialogContentProps}
      modalProps={modalPropsStyles}
      minWidth={500}
    >
      <Form layout="vertical">
        <FormItem label="Query By">
          <Radio.Group
            buttonStyle="solid"
            value={queryType}
            onChange={({ target }) => {
              setQueryType(target.value);
            }}
          >
            <Radio.Button value="specific">Specific Month</Radio.Button>
            <Radio.Button value="range">Month Range</Radio.Button>
            <Radio.Button value="inception">
              Production From Inception
            </Radio.Button>
          </Radio.Group>
        </FormItem>
        {queryType === "specific" ? (
          <FormItem label="Choose production date">
            <DatePicker
              style={{ width: "213px" }}
              onChange={(date, dateString) => {
                if (date) {
                  setQueryDate({ ...queryDate, startDate: getPickerDate(date) });
                }
              }}
              picker="month"
            />
          </FormItem>
        ) : queryType === "range" ? (
          <FormItem label="Choose production date range">
            <RangePicker
              style={{ width: "300px" }}
              onChange={(date, dateString) => {
                if (date) {
                  const [start, end] = date;
                  setQueryDate({
                    startDate: getPickerDate(start),
                    endDate: getPickerDate(end),
                  });
                }
              }}
              picker="month"
            />
          </FormItem>
        ) : null}
      </Form>

      <DialogFooter>
        <Space>
          {monthlyPerformanceStore.isLoading && (
            <ProgressIndicator
              description="querying, please wait..."
              styles={{ root: { width: "200px", textAlign: "left" } }}
            />
          )}
          <Button
            type="link"
            onClick={() => {
              monthlyPerformanceStore.showSQeryDialog = false;
            }}
          >
            Close
          </Button>
          <Button
            loading={monthlyPerformanceStore.isLoading}
            type="primary"
            onClick={async () => {
              setLoading(true);
              try {
                let queryCriteria = {};
                monthlyPerformanceStore.resultFromQuery = true;
                if (queryType === "specific") {
                  if (!_.isDate(queryDate.startDate)) {
                    notification.info({
                      message: "SPARS Feedback",
                      description: "select valid production date",
                    });
                    return;
                  }
                  queryCriteria = {
                    startDate: moment(queryDate.startDate).format(
                      "YYYY-MM-01T00:00:00.000Z"
                    ),
                    endDate: moment(queryDate.startDate).format(
                      "YYYY-MM-01T00:00:00.000Z"
                    ),
                    fromInception: false,
                    specificDate: true,
                  };

                  monthlyPerformanceStore.gridHeaderText = ` NAOC MONTHLY PRODUCTIONS for ${moment(
                    queryCriteria.startDate
                  ).format("MMM-YYYY")} `;
                } else if (queryType === "range") {
                  if (
                    !_.isDate(queryDate.startDate) ||
                    !_.isDate(queryDate.endDate)
                  ) {
                    notification.info({
                      message: "SPARS Feedback",
                      description: "select valid production date",
                    });
                    return;
                  }
                  queryCriteria = {
                    startDate: moment(queryDate.startDate).format(
                      "YYYY-MM-01T00:00:00.000Z"
                    ),
                    endDate: moment(queryDate.endDate).format(
                      "YYYY-MM-01T00:00:00.000Z"
                    ),
                    fromInception: false,
                    specificDate: false,
                  };

                  monthlyPerformanceStore.gridHeaderText = `NAOC MONTHLY PRODUCTIONS ${moment(
                    queryCriteria.startDate
                  ).format("MMM-YYYY")} to ${moment(
                    queryCriteria.endDate
                  ).format("MMM-YYYY")}`;
                } else if (queryType === "inception") {
                  queryCriteria = {
                    startDate: moment(new Date())
                      .startOf("month")
                      .format("YYYY-MM-01T00:00:00.000Z"),
                    endDate: moment(new Date())
                      .startOf("month")
                      .format("YYYY-MM-01T00:00:00.000Z"),
                    fromInception: true,
                    specificDate: false,
                  };

                  monthlyPerformanceStore.gridHeaderText = `NAOC MONTHLY PRODUCTIONS from Inception`;
                }
                monthlyPerformanceStore.showSQeryDialog = false;
                monthlyPerformanceStore.queryCriteria = queryCriteria;
                await monthlyPerformanceStore.loadProductions();
              } catch (error) {
                monthlyPerformanceStore.gridHeaderText = "";
                notification.error({
                  message: "SPARS Feedback",
                  description: error.message,
                });
              } finally {
                setLoading(false);
              }
            }}
          >
            Query
          </Button>
        </Space>
      </DialogFooter>
    </Dialog>
  );
});

